import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field, itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm';
import Uploader from 'src/constrains/SingleImageUploader';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  imageLayerImage,
  imageLayerLinkModule,
  imageSetting,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';

const ImageLink = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, validators, breakpoint } = props;
  const { image: iV, link: lV } = validators || {};
  const _params: any = useParams();
  const { contentUuid } = _params;
  return (
    <Section {...sectionProps}>
      <Field
        name={imageLayerImage}
        rules={[
          {
            // validateTrigger: 'onSubmit',
            validator: async (rules: any, value: any) => {
              if (iV) {
                const res = iV(value, { breakpoint });
                const hasError = get(res, 'hasError');
                const errors = get(res, 'errors');
                if (hasError) {
                  return Promise.reject(new Error((errors || []).join(',')));
                  //</ItemWrapper>throw Error((errors || []).join(','));
                }
              }
            },
          },
        ]}>
        {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
          const e = itemWrapperErrorDisplayAdaptor(meta);
          return (
            <ItemWrapper
              title={getI18n('general.tools_helper.image')}
              bottomTitle={`${getI18n(
                'general.allowedfiletypes',
              )}: jpeg, gif, png`}
              size='small'
              {...e}>
              <Uploader height={180} {...props} />
            </ItemWrapper>
          );
        }}
      </Field>
      <Field
        shouldUpdate={(p, c) => {
          return get(p, `${imageLayerImage}`) !== get(c, `${imageLayerImage}`);
        }}>
        {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
          const image = getFieldValue(imageLayerImage);
          return (
            <Field name={[imageLayerImage, imageSetting]}>
              {(props, meta) => {
                //const value = props.value;
                const onChange = props.onChange;
                return (
                  <FocusPoint
                    image={image}
                    onChange={(image) => {
                      onChange(get(image, 'image.imageSetting'));
                    }}
                  />
                );
              }}
            </Field>
          );
        }}
      </Field>
      {!disabled && (
        <Field
          name={imageLayerLinkModule}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (lV) {
                  const res = lV(value, { breakpoint });

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, meta) => {
            const value = props.value;
            const onChange = props.onChange;
            const errors = get(meta, 'errors');
            return (
              <LinkLibraryWithSisterScScope
                error={errors || []}
                data={value}
                onChange={onChange}
                salesChannelContentUuid={contentUuid}
              />
            );
          }}
        </Field>
      )}
    </Section>
  );
};
export default ImageLink;
